import { render, staticRenderFns } from "./ExportTickets.vue?vue&type=template&id=485892eb&"
import script from "./ExportTickets.vue?vue&type=script&lang=js&"
export * from "./ExportTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports